import { AdditionalMedicineForPrescriptionReleaseStruct } from "./additional-medicine-for-prescription-release.struct";
import { StorageAmountLocationStruct } from "./storage-amount-location.struct";

export class AdditionalMedicineForPrescriptionReleaseFormStruct {
    public additionalMedicineForPrescriptionRelease: AdditionalMedicineForPrescriptionReleaseStruct;

    public listStorageAmountLocationStruct: StorageAmountLocationStruct[] = [];
}